'use client';

import ChartVerticalIcon from './ChartVertical.js';
import LanguageIcon from './Language.js';
import EmptyHotCategoryIcon from './EmptyHotCategory.js';
import LawyerIcon from './Lawyer.js';

var AccountCenter = {
    ChartVerticalIcon: ChartVerticalIcon,
    LanguageIcon: LanguageIcon,
    EmptyHotCategoryIcon: EmptyHotCategoryIcon,
    LawyerIcon: LawyerIcon
};

export { AccountCenter as default };
//# sourceMappingURL=index.js.map
